// extracted by mini-css-extract-plugin
export default {"freePalletsAmount":"FreePalletAmountInfo_freePalletsAmount__yEtg2","green":"FreePalletAmountInfo_green__gZK3r"};